import { SlBadge } from "react-icons/sl";
import SIZE from "./size";
import * as Popover from "@radix-ui/react-popover";
import BRILLIANT_EFFORT from "../../../../assets/icons/badges/brilliant-effort.svg";
import CREATIVE_THINKER from "../../../../assets/icons/badges/creative-thinker.svg";
import EXEMPLARY_LEADER from "../../../../assets/icons/badges/exemplary-leader.svg";
import STAR_PARTICIPANT from "../../../../assets/icons/badges/star-participant.svg";
import TEAM_PLAYER from "../../../../assets/icons/badges/team-player.svg";
import TOP_CONTRIBUTOR from "../../../../assets/icons/badges/top-contributor.svg";
import { TiArrowForwardOutline } from "react-icons/ti";
import React, { useState, useEffect, useRef, useContext } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import ShareBadge from "./ShareBadge";
import { useDispatch, useSelector } from "react-redux";
import { clearNewBadgeNotification, fetchLiveSessionSettings, fetchOnlineParticipants, setNewBadgeNotification, updateLiveStreamSettings } from "../../../../store/reducers/livestreamSettings";
import { AppDispatch, RootState } from "../../../../store";
import ShareBadgePopover from "./ShareBadgePopover";
import { socketContextType } from "index";
import SocketContext from "socket-context";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import { socketMessageType } from "types/Constants";
import axiosInstance from "config/axios";
import _ from 'lodash';
import { User } from "models/User";

interface BadgeControlProps {
  showButton?: boolean;
  inDrawer?: boolean;
}
const BadgeControl = ({ showButton, inDrawer = false }: BadgeControlProps) => {
  const settings = useSelector((state: RootState) => state.live.settings);
  const profileData = useSelector((state: any) => state?.auth?.user as User);
  const sessionData = useSelector((state: any) => state?.live.settings?.session);
  const dispatch = useDispatch<AppDispatch>();
  const [togglePage, setTogglePage] = useState(false);
  // const [sharedBadge, setSharedBadge] = useState<string | null>(null);
  const [view, setView] = useState<"grid" | "share">("grid");
  const [selectedBadge, setSelectedBadge] = useState<{ alt: string, src: string } | null>(null);
  const [badgesData, setBadgesData] = useState<any[]>([]);
  let userInfoHandler = useRef<UserInfoMapperSocketHandler>(null);
  const session_id: any = useSelector(
    (state: RootState) => state.live.settings.roomId
  );


  useEffect(() => {
    dispatch(fetchLiveSessionSettings(session_id));
  }, [session_id])

  const initialBadgesData = [
    {
      id: 1,
      name: "CREATIVE THINKER",
      badge: <img src={CREATIVE_THINKER} alt="CREATIVE THINKER" className="w-20 h-20" />,
      receivedCount: "0",
      senderName: [],
    },
    {
      id: 2,
      name: "BRILLIANT EFFORT",
      badge: <img src={BRILLIANT_EFFORT} alt="BRILLIANT EFFORT" className="w-20 h-20" />,
      receivedCount: "0",
      senderName: [],
    },
    {
      id: 3,
      name: "EXEMPLARY LEADER",
      badge: <img src={EXEMPLARY_LEADER} alt="EXEMPLARY LEADER" className="w-20 h-20" />,
      receivedCount: "0",
      senderName: [],
    },
    {
      id: 4,
      name: "STAR PARTICIPANT",
      badge: <img src={STAR_PARTICIPANT} alt="STAR PARTICIPANT" className="w-20 h-20" />,
      receivedCount: "0",
      senderName: [],
    },
    {
      id: 5,
      name: "TEAM PLAYER",
      badge: <img src={TEAM_PLAYER} alt="TEAM PLAYER" className="w-20 h-20" />,
      receivedCount: "0",
      senderName: [],
    },
    {
      id: 6,
      name: "TOP CONTRIBUTOR",
      badge: <img src={TOP_CONTRIBUTOR} alt="TOP CONTRIBUTOR" className="w-20 h-20" />,
      receivedCount: "0",
      senderName: [],
    },
  ];

  const socketList: socketContextType[] = useContext(SocketContext);
  const getReceivedBadges = () => {
    let data = {
      email: profileData?.email,
      sessionMapId: sessionData?.mapID
    }
    axiosInstance.post("/trainee/get_badges", data)
      .then((res: any) => {
        if (res?.data?.getBadge && res?.data?.getBadge?.length > 0) {
          const _badgesData = initialBadgesData.map((badge) => ({
            ...badge,
            receivedCount: "0",
            senderName: [],
          }));
          res.data.getBadge.forEach((element: any) => {
            const badgeName = element.achievementName.toUpperCase();
            const index = _badgesData.findIndex((e) => e.name === badgeName);
            if (index !== -1) {
              _badgesData[index].senderName = _.uniq([
                ..._badgesData[index].senderName,
                element.senderName,
              ]);
              _badgesData[index].receivedCount = String(
                parseInt(_badgesData[index].receivedCount) + 1
              );
            }
          });
          setBadgesData(_badgesData);
        } else {
          setBadgesData(initialBadgesData);
        }
      })
      .catch(error => {
        console.log('save badges error -->', error);
      });
  }

  const handleOnMessage = (msg: string) => {
    const data = JSON.parse(msg);
    if (data?.type === socketMessageType.SHOW_BADGES) {
      const isRecipient = data.user_badge_data.sent_to.includes(profileData?.email);
      if (isRecipient) {
        dispatch(setNewBadgeNotification());
        getReceivedBadges();
        dispatch(fetchLiveSessionSettings(session_id));
      }
    }
  };


  useEffect(() => {
    if (!userInfoHandler.current) {
      userInfoHandler.current = validateAndCreateSocketIfExist(
        session_id,
        handleOnMessage,
        socketList
      );
    }
    getReceivedBadges();
    dispatch(fetchLiveSessionSettings(session_id));
  }, []);

  useEffect(() => {
    if (inDrawer) {
      setTogglePage(false);
      setView("grid");
      setSelectedBadge(null);
    }
  }, [inDrawer]);


  const handleShareClick = (badge: JSX.Element) => {
    const alt = badge.props.alt;
    const src = badge.props.src;
    setSelectedBadge({ alt, src });
    setView("share");
  };

  const resetToGrid = () => {
    setSelectedBadge(null);
    setView("grid");
  };

  const buttonShadow = "-2px -2px 12px 0 rgba(255, 255, 255, 0.25), 6px 6px 12px 0 rgba(0, 0, 0, 0.25)";

  const BadgePanelContent = () => (
    <div className="w-full text-white">
      <div className="flex justify-between items-center gap-2 mobile:flex-col mobile:gap-3 mb-4">
        <button
          onClick={() => {
            setTogglePage(false);
            setView("grid");
          }}
          onTouchEnd={() => {
            setTogglePage(false);
            setView("grid");
          }}
          className={`
            w-full px-3 py-2 rounded-3xl text-sm font-medium relative z-[70]
            ${!togglePage ? "bg-[#5F488A]" : "bg-[#24272C]"}
            mobile:text-xs mobile:py-2.5
          `}
          style={{ boxShadow: buttonShadow }}
        >
          Share Badges
        </button>
        <button
          onClick={() => {
            setTogglePage(true);
            setView("grid");
          }}
          onTouchEnd={() => {
            setTogglePage(true);
            setView("grid");
          }}
          className={`
            w-full px-3 py-2 rounded-3xl text-sm font-medium relative z-[70]
            ${togglePage ? "bg-[#5F488A]" : "bg-[#24272C]"}
            mobile:text-xs mobile:py-2.5
          `}
          style={{ boxShadow: buttonShadow }}
        >
          View Collected Badges
        </button>
      </div>

      {!togglePage && view === "grid" && (
        <div className="grid grid-cols-3 gap-4 mobile:grid-cols-2 mobile:gap-3">
          {initialBadgesData.map((badgeData, index) => (
            <div key={index} className="flex flex-col items-center space-y-1">
              <button
                className="bg-[#24272C] text-white rounded-3xl text-xs px-2 py-1 flex items-center mobile:text-[10px] mobile:px-1.5 mobile:py-0.5"
                style={{ boxShadow: buttonShadow }}
                onClick={() => handleShareClick(badgeData.badge)}
              >
                <span className="mr-1">
                  <TiArrowForwardOutline />
                </span>
                Share
              </button>
              {React.cloneElement(badgeData.badge, {
                className: "w-16 h-16 mobile:w-14 mobile:h-14",
              })}
              <span className="text-xs mobile:text-[10px] text-center">{badgeData.name}</span>
            </div>
          ))}
        </div>
      )}

      {!togglePage && view === "share" && selectedBadge && (
        <div className="mt-4">
          <ShareBadgePopover badge={selectedBadge} onBack={resetToGrid} />
        </div>
      )}

      {togglePage && (
        <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-2">
          {badgesData.filter((d) => d.senderName.length > 0).length > 0 ? (
            badgesData
              .filter((d) => d.senderName.length > 0)
              .map((data, i) => (
                <div key={i} className="bg-[#24272C] rounded-lg p-3 shadow-lg">
                  <div className="flex items-center gap-3">
                    <div className="flex-shrink-0">
                      {React.cloneElement(data.badge, { className: "w-16 h-16" })}
                    </div>
                    <div className="flex-1">
                      <div className="text-lg font-bold text-yellow-400">{data.receivedCount}</div>
                      <div className="text-xs text-gray-400">Received</div>
                    </div>
                  </div>
                  <div className="mt-2 text-xs">
                    <span className="italic text-gray-400">Shared by:</span>
                    <div className="flex flex-wrap gap-1 mt-1">
                      {data.senderName.map((name: string, j: number) => (
                        <span key={j} className="bg-[#333] px-2 py-0.5 rounded text-xs">
                          {name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className="text-center text-gray-400 text-sm">No badges received yet</div>
          )}
        </div>
      )}
    </div>
  );
  if (!inDrawer) {
    return (
      <Popover.Root>
        <Popover.Trigger asChild>
          {showButton ? (
            <div
              className={`
              flex h-12 w-12
              largescreen:h-14 largescreen:w-14
              items-center justify-center rounded-full cursor-pointer
              mobile:h-10 mobile:w-10   /* ← mobile button size */
            `}
              style={{
                background: "rgb(95, 72, 138)",
                boxShadow:
                  "rgb(152, 122, 209) -8px -8px 16px inset, rgba(2, 2, 2, 0.61) 8px 8px 8px inset",
              }}
              onClick={() => {
                dispatch(
                  updateLiveStreamSettings({ badgesPanel: !settings.badgesPanel })
                );
                dispatch(clearNewBadgeNotification());
              }}
            >
              <SlBadge color="white" size={24} />
            </div>
          ) : (
            <button className="text-black text-sm">Badges</button>
          )}
        </Popover.Trigger>

        <Popover.Portal>
          <Popover.Content
            className={`
            bg-zinc-900 p-6 rounded-2xl w-full text-white z-[60]
            mobile:p-4 mobile:max-w-[95vw]   /* ← tighter padding & max-width */
          `}
            sideOffset={5}
          >
            <Popover.Close
              className={`
              absolute text-white cursor-pointer
             mobile:top-[-36px] mobile:right-2
             mobile:w-12 mobile:h-12
            `}
              style={{
                fontSize: "12px",
                backgroundColor: "#19191c",
                borderRadius: "20px",
                filter:
                  "drop-shadow(2px 2px 4px rgba(0,0,0,0.25)) drop-shadow(-2px -2px 4px rgba(255,255,255,0.25))",
                backdropFilter: "blur(16px)",
                zIndex: -9,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="../img/cancel.webp" alt="close" />
            </Popover.Close>

            <div className="flex justify-between items-center gap-2 mobile:flex-col mobile:gap-3">
              <button
                onClick={() => {
                  setTogglePage(false);
                  setView("grid");
                }}
                className={`
                w-full h-full px-3 py-2 rounded-3xl text-sm
                ${!togglePage ? "bg-[#5F488A]" : "bg-[#24272C]"}
               mobile:text-xs mobile:py-3
              `}
                style={{ boxShadow: buttonShadow }}
              >
                Share Badges
              </button>
              <button
                onClick={() => {
                  setTogglePage(true);
                  setView("grid");
                }}
                className={`
                w-full h-full px-3 py-2 rounded-3xl text-sm
                ${togglePage ? "bg-[#5F488A]" : "bg-[#24272C]"}
               mobile:text-xs mobile:py-3
              `}
                style={{ boxShadow: buttonShadow }}
              >
                View Collected Badges
              </button>
            </div>

            {!togglePage && view === "grid" && (
              <div
                className={`
                grid grid-cols-3 gap-6 mt-4
                mobile:grid-cols-2 mobile:gap-4 mobile:mt-3
              `}
              >
                {initialBadgesData.map((badgeData, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center space-y-2 mobile:space-y-1"
                  >
                    <button
                      className={`
                      bg-[#24272C] text-white rounded-3xl text-xs px-2 py-1 flex items-center
                     mobile:text-[10px] mobile:px-1.5 mobile:py-0.5
                    `}
                      style={{ boxShadow: buttonShadow }}
                      onClick={() => handleShareClick(badgeData.badge)}
                    >
                      <span className="mr-1">
                        <TiArrowForwardOutline />
                      </span>
                      Share
                    </button>

                    {/* badge image – shrink on mobile */}
                    {React.cloneElement(badgeData.badge, {
                      className: `w-20 h-20 mobile:w-16 mobile:h-16`,
                    })}

                    <span
                      className={`
                      text-white text-sm lowercase capitalize
                     mobile:text-xs
                    `}
                    >
                      {badgeData.name}
                    </span>
                  </div>
                ))}
              </div>
            )}

            {!togglePage && view === "share" && selectedBadge && (
              <ShareBadgePopover badge={selectedBadge} onBack={resetToGrid} />
            )}
            {togglePage && (
              <div
                className={`
                space-y-4 h-fit overflow-y-auto pr-2 mt-2
               mobile:h-[70vh] mobile:space-y-3 mobile:mt-3
              `}
              >
                {badgesData.length > 0 ? (
                  badgesData
                    .filter((d) => d.senderName.length > 0)
                    .map((data, index) => (
                      <div key={index} className="my-2 mobile:my-1">
                        <div className="grid grid-cols-[40%_60%] shadow-xl items-stretch relative">
                          <div
                            className={`
                            bg-[#32363D] flex items-center justify-center space-x-4 py-4 px-4 rounded-lg shadow z-10 mr-[-8px]
                           mobile:py-2 mobile:px-2 mobile:space-x-2
                          `}
                          >
                            <div className="w-60 h-30 mobile:w-20 mobile:h-20">
                              {React.cloneElement(data.badge, {
                                className: "w-full h-full object-contain",
                              })}
                            </div>
                            <div className="text-app-blue items-center justify-center py-8 mobile:py-2">
                              <div className="text-3xl text-white font-bold px-4 mobile:text-2xl mobile:px-1">
                                {data.receivedCount}
                              </div>
                            </div>
                          </div>

                          <div className="bg-[#24272C] flex flex-col rounded-lg shadow z-0">
                            <div className="text-white px-4 py-2 text-sm flex items-center border-b border-white mobile:px-2 mobile:py-1 mobile:text-xs">
                              <span className="italic">Shared by</span>
                            </div>
                            <div className="max-h-24 overflow-y-auto px-4 py-2 space-y-1 text-white font-normal text-sm mobile:px-2 mobile:py-1 mobile:text-xs">
                              {data.senderName.map((name: string, i: number) => (
                                <div key={i}>{name}</div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="text-white text-center mobile:text-sm">
                    No badges received yet
                  </div>
                )}
              </div>
            )}
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    );
  }
  return <BadgePanelContent />;
};

export default BadgeControl;